import { bus, helper } from '../../utils'

export default {
  beforeDestroy () {
    bus.$off('show-upload-information-model-images')
  },
  computed: {
    bannerName () {
      return this.getFieldName('banner')
    },
    bannerUri () {
      return this.images.banner && this.images.banner.uri
    },
    setFieldData () {
      return {
        Thumbnail: {
          currentImgSrc: this.thumbnailUri,
          description: this.$t('informationModelImagesUploadInputThumbnailDescription'),
          imageErrorMsg: this.$t('informationModelImagesUploadInputThumbnailError'),
          isLocal: false,
          isValidImageSize: true,
          label: this.$t('informationModelImagesUploadInputThumbnailLabel'),
          minimumHeight: 240,
          minimumWidth: 240,
          model: this.data.thumbnail,
          name: this.thumbnailName,
          selectedFileName: this.thumbnailFileName || this.$t('NoFileChosen'),
          uri: this.thumbnailUri,
          validate: 'mimes:image/jpg,image/jpeg,image/png,image/gif|size:2048'
        },
        Banner: {
          currentImgSrc: this.bannerUri,
          description: this.$t('informationModelImagesUploadInputBannerDescription'),
          imageErrorMsg: this.$t('informationModelImagesUploadInputBannerError'),
          isLocal: false,
          isValidImageSize: true,
          label: this.$t('informationModelImagesUploadInputBannerLabel'),
          minimumHeight: 240,
          minimumWidth: 750,
          model: this.data.banner,
          name: this.bannerName,
          selectedFileName: this.bannerFileName || this.$t('NoFileChosen'),
          uri: this.bannerUri,
          validate: 'mimes:image/jpg,image/jpeg,image/png,image/gif|size:2048'
        }
      }
    },
    thumbnailName () {
      return this.getFieldName('thumbnail')
    },
    thumbnailUri () {
      return this.images.thumbnail && this.images.thumbnail.uri
    }
  },
  methods: {
    async uploadImages () {
      for (const id in this.uploadData) {
        const file = this.uploadData[id]
        if (file) {
          const { name, list, fileName } = file
          this.data.formData.append(name, list, fileName)
        }
      }

      const apiArr = [ this.$api.updateInfoModelImages(this.data.formData) ]
      if (this.removedImages.imageTypes.length) {
        apiArr.push(this.$api.removeInfoModelImages(this.removedImages))
      }

      return Promise.all(apiArr)
        .then(() => this.successCallback())
        .catch(error => this.failedCallback(error))
    },
    closePopup () {
      this.reset()
      this.showModal = false
    },
    failedCallback (error) {
      this.loading = false
      helper.showErrorMessage(this, this.component, error)
    },
    filesChange (id, fieldName, fileList) {
      const fileExist = !!(fileList && fileList[0])
      const currentFileName = fileExist && fileList[0].name ? fileList[0].name : this.$t('NoFileChosen')
      const field = this.fieldsData[id]

      if (fileExist) {
        field.selectedFileName = currentFileName
        const reader = new FileReader()
        reader.onload = () => {
          field.currentImgSrc = reader.result

          const image = new Image()
          image.src = reader.result
          image.onload = () => {
            const isValid = field.minimumHeight <= image.height && field.minimumWidth <= image.width
            field.isValidImageSize = isValid
          }
        }
        reader.readAsDataURL(fileList[0])

        this.uploadData[id] = {
          name: fieldName,
          list: fileList[0],
          fileName: fileList[0].name
        }

        const newId = id.toLowerCase()
        const imageTypes = this.removedImages.imageTypes
        const index = imageTypes.indexOf(newId)
        if (index !== -1) {
          imageTypes.splice(index, 1)
        }
      }
    },
    getFieldName (name) {
      if (!name || typeof name !== 'string') {
        throw new Error('The filed name is required and it should be a string.')
      }
      return `${this.familyName}-${name}`
    },
    removeImage (id, name) {
      this.fieldsData[id].isLocal = true
      document.getElementById(name).value = ''

      this.fieldsData[id].currentImgSrc = null
      this.fieldsData[id].selectedFileName = this.$t('NoFileChosen')

      const newId = id.toLowerCase()
      const removedImages = this.removedImages
      const imageTypes = removedImages.imageTypes
      if (!imageTypes.includes(newId)) {
        removedImages.familyName = this.familyName
        imageTypes.push(newId)
        delete this.uploadData[id]
      }
    },
    reset () {
      document.getElementById(this.bannerName).value = ''
      document.getElementById(this.thumbnailName).value = ''

      this.bannerFileName = ''
      this.data = {
        thumbnail: null,
        banner: null,
        formData: new FormData()
      }
      this.fieldsData = {}
      this.images = {}
      this.removedImages = {
        familyName: null,
        imageTypes: []
      }
      this.thumbnailFileName = ''
      this.uploadData = {}
      this.$nextTick(() => {
        this.$validator.reset()
        this.$validator.errors.clear()
      })
    },
    save () {
      return this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.loading = true
            this.uploadImages()
          }
        })
    },
    successCallback () {
      bus.$emit('get-information-model-list')
      this.loading = false
      this.closePopup()
    },
    whenImageNotFound (id) {
      this.fieldsData[id].isLocal = true
    }
  },
  name: 'InformationModelImagesUpload',
  data () {
    return {
      bannerFileName: '',
      component: 'informationModelImagesUpload',
      data: {
        thumbnail: null,
        banner: null,
        formData: new FormData()
      },
      dialogProps: {
        beforeClose: () => this.closePopup()
      },
      familyName: '',
      fieldsData: {},
      i18n: {
        informationModelImagesUploadButtonRemoveImageText: this.$t('informationModelImagesUploadButtonRemoveImageText'),
        informationModelImagesUploadButtonUploadImageText: this.$t('informationModelImagesUploadButtonUploadImageText'),
        informationModelImagesUploadDialogButtonCloseText: this.$t('informationModelImagesUploadDialogButtonCloseText'),
        informationModelImagesUploadDialogButtonSaveText: this.$t('informationModelImagesUploadDialogButtonSaveText'),
        informationModelImagesUploadDialogTitle: this.$t('informationModelImagesUploadDialogTitle'),
        informationModelImagesUploadInputBannerDescription: this.$t('informationModelImagesUploadInputBannerDescription'),
        informationModelImagesUploadInputBannerError: this.$t('informationModelImagesUploadInputBannerError'),
        informationModelImagesUploadInputBannerLabel: this.$t('informationModelImagesUploadInputBannerLabel'),
        informationModelImagesUploadInputThumbnailDescription: this.$t('informationModelImagesUploadInputThumbnailDescription'),
        informationModelImagesUploadInputThumbnailError: this.$t('informationModelImagesUploadInputThumbnailError'),
        informationModelImagesUploadInputThumbnailLabel: this.$t('informationModelImagesUploadInputThumbnailLabel')
      },
      images: {},
      labelWidth: '150px',
      loading: false,
      removedImages: {
        familyName: null,
        imageTypes: []
      },
      showModal: false,
      thumbnailFileName: '',
      uploadData: {}
    }
  },
  mounted () {
    bus.$on('show-upload-information-model-images', ({ familyName, show, images }) => {
      if (familyName) {
        this.familyName = familyName
      }

      if (show) {
        this.showModal = true
      }

      if (images) {
        this.images = images
      }

      this.fieldsData = this.setFieldData
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/InformationModelImagesUpload/InformationModelImagesUpload.js